<script setup lang="ts">
import type { ShowcaseContentListItemDto } from '@repo/api/web/models'
import { useIntersectionObserver } from '@vueuse/core'

import ContentCard from '../Card/ContentCard.vue'

const props = defineProps<{
  items: ShowcaseContentListItemDto[]
  pending?: boolean
  /** Базовый путь детальных страниц ('/news', '/blog') */
  basePath: string
  emptyText: string
  /** href краулябельной ссылки «Следующая страница» */
  nextHref?: string
}>()

const emit = defineEmits<{
  loadMore: []
}>()

const sentinel = useTemplateRef('sentinel')
useIntersectionObserver(sentinel, ([entry]) => {
  if (entry?.isIntersecting) emit('loadMore')
})
</script>

<template>
  <div class="content-feed-list">
    <div
      v-if="props.pending && !props.items.length"
      class="flex justify-center py-16"
      aria-busy="true"
    >
      <UIcon
        name="i-lucide-loader-circle"
        class="animate-spin text-2xl text-muted"
      />
    </div>

    <p
      v-else-if="!props.items.length"
      class="py-10 text-center text-muted"
    >
      {{ props.emptyText }}
    </p>

    <div
      v-else
      class="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3 xl:grid-cols-4"
    >
      <ContentCard
        v-for="item in props.items"
        :key="item.slug"
        :value="item"
        :base-path="props.basePath"
      />
    </div>

    <div
      v-if="props.pending && props.items.length"
      class="flex justify-center py-6"
      aria-busy="true"
    >
      <UIcon
        name="i-lucide-loader-circle"
        class="animate-spin text-2xl text-muted"
      />
    </div>

    <div
      ref="sentinel"
      class="h-px"
    />

    <nav
      v-if="props.nextHref"
      class="mt-6 flex justify-center py-2"
      aria-label="Пагинация"
    >
      <a
        :href="props.nextHref"
        rel="next"
        class="text-sm text-muted underline-offset-4 hover:underline"
      >
        Следующая страница
      </a>
    </nav>
  </div>
</template>
